import { render, staticRenderFns } from "./CommitInfo.vue?vue&type=template&id=5071fe20"
import script from "./CommitInfo.vue?vue&type=script&lang=js"
export * from "./CommitInfo.vue?vue&type=script&lang=js"
import style0 from "./CommitInfo.vue?vue&type=style&index=0&id=5071fe20&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports